import { ofType } from 'redux-observable';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { throttleUntilChanged } from '../../utils/rxjs-utils';
import * as actionType from '../../store/state/actions';
import { ActionManagerInstance } from '../../actions/manager';
import * as actions from '../../store/state/actions/action-creators';
import * as StateManager from '../../store/state/state-manager';
import { getResolvedTargetName } from '../../router/routing-manager';
import { isErrorActionType } from '../../case/common-helper';
import { CONTAINER_NAMES } from '../../container/container-utils';
import { processDataToDispatchErrorAction } from '../../store/state/epics/util';
import { publicConstants } from '../../constants';
import type { Action } from '../../store/state/state-manager';

import executeCreateDataObjectRequest from './async-request';
import { createDataObjectAction } from './action-creator';

const createDataObject = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: any[] = [];

  return action$.pipe(
    ofType(actionType.CREATE_DATA_OBJECT),
    throttleUntilChanged(100),
    switchMap((action: Action) => {
      const { isFormValid } = action.payload;
      ({ actionMgrID } = action.payload);
      if (!isFormValid) {
        const error = { type: publicConstants.SUBMISSION_FAILURE_TYPE.FORM_VALIDATION_ERROR };
        ActionManagerInstance.rejectActionByID(actionMgrID, true, error);
        // return empty observable as form is not valid.
        return of([]);
      }
      return of(action.payload).pipe(
        mergeMap((payload: Action['payload']) => {
          return executeCreateDataObjectRequest(payload);
        }),
        mergeMap(async (data) => {
          if (data && data.type === actionType.ERROR) {
            const { payload } = data;
            const errorAction = processDataToDispatchErrorAction({ ...data, ...payload, actionMgrID });
            actionsOut.push(errorAction);
            return actionsOut;
          }
          const { actionInPayload } = data;
          const { containerItemID, isModalAction } = actionInPayload;
          const containerName = isModalAction ? CONTAINER_NAMES.MODAL : CONTAINER_NAMES.PRIMARY;
          const target = getResolvedTargetName(containerName, containerItemID);
          const payload = { target, containerItemID, context: containerItemID };
          actionsOut.push(actions.postProcess(actions.removeContainerItem, payload));
          return actionsOut;
        }),
        map(() => {
          if (actionsOut.length === 1 && isErrorActionType(actionsOut[0].type)) {
            ActionManagerInstance.rejectActionByID(actionMgrID);
          } else {
            ActionManagerInstance.resolveActionByID(actionMgrID);
          }
          StateManager.dispatch(actionsOut);
          actionsOut = [];
          return actionsOut;
        })
      );
    })
  );
};

export { createDataObject, createDataObjectAction };
